import OutperformedAnimatedExhibit from "./OutperformedAnimatedExhibit";
import DataContainer from "components/utility/data-container/DataContainer";
const OutperformedAnimatedExhibitPage = ({ dataset }) => {
	return (
		<div>
			<DataContainer data={"outPerformedGraph"}>
				<OutperformedAnimatedExhibit dataset={dataset} />
			</DataContainer>
		</div>
	);
};

export default OutperformedAnimatedExhibitPage;
